export const LETTERS = [
    ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
    ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
    ["shift", "z", "x", "c", "v", "b", "n", "m", "backspace"],
    ["123", "space", "enter"]
];

export const SYMBOLS = [
    ["1","2","3","4","5","6","7","8","9","0"],
    ["@","#","€","&","-","+","(",")","/","*"],
    [".",",","?","!","'","\"","=","backspace"],
    ["abc","space","enter"]
];
